import { render, staticRenderFns } from "./HeaderNews.vue?vue&type=template&id=2108e1c8&scoped=true&"
import script from "./HeaderNews.vue?vue&type=script&lang=ts&"
export * from "./HeaderNews.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNews.vue?vue&type=style&index=0&id=2108e1c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108e1c8",
  null
  
)

export default component.exports